import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {FocalPointImage} from "./FocalPointImage";
import {HitImageWrapper} from "Components/Search/hits/StyledSearch";

export const StyledBackgroundImage = styled(FocalPointImage).attrs(
    ({bgImage, fadeIn, HeroCurvedTextArea, smallBorderRadius, theme}) => ({
        bgImage: bgImage ? bgImage : "",
        show: fadeIn !== undefined ? fadeIn : false,
        heroCurvedTextArea: HeroCurvedTextArea,
        smallBorderRadius: smallBorderRadius ? smallBorderRadius : theme.border.radius
    })
)`
    border-radius: ${({theme}) => theme.border.radius};
    border-bottom-left-radius: ${({noRadiusBottom}) =>
            noRadiusBottom ? 0 : ""};
    border-bottom-right-radius: ${({noRadiusBottom}) =>
            noRadiusBottom ? 0 : ""};

    background-image: ${({bgImage}) => `url(${bgImage})`};
    flex-basis: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;

    opacity: 0;
    transition: opacity 0.2s ease-in-out;

    ${({show}) =>
            show &&
            css`
                opacity: 1;
            `}
    ${({heroCurvedTextArea}) =>
            heroCurvedTextArea &&
            css`
                overflow: hidden;
            `}
    & {
        ${media.lessThan(breakpoints.ipadPlus)`
		  border-radius: ${({smallBorderRadius}) => smallBorderRadius};

  `}
`;

export const Placeholder = styled(StyledBackgroundImage)`
    ${({placeholder, fadeIn}) =>
            !fadeIn && placeholder && css`
                background-image: ${({placeholder}) => `url(${placeholder})`};
            `
    }
    position: absolute;
`;

export const ImageWrapper = styled.div.attrs(({height, minHeight}) => ({
    height: height ? height : "100%",
    minHeight: minHeight ? minHeight : 'inherit'
}))`
    position: relative;
    width: 100%;

    &:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: ${({paddingBottom}) =>
                paddingBottom ? paddingBottom : "56.25%"};
        overflow: hidden;
    }

    ${media.greaterThan(breakpoints.ipad)`
		height: ${({height}) => height};
		min-height: ${({minHeight}) => minHeight};
	`}
`;
